<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { cn } from "@/lib/utils"

const props = defineProps<{
  class?: HTMLAttributes["class"]
}>()
</script>

<template>
  <div :class="cn('flex items-center gap-2 p-3 pt-2 border-t border-border bg-muted/60 dark:bg-[hsl(var(--border))] text-xs', props.class)">
    <slot />
  </div>
</template>
